import React from 'react';
import { message, Space, Tag, Row, Col, Descriptions, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { httpClient } from "util/Api";
import { compareUIElementValue } from 'util/Compare';
import { config } from "util/config";
import * as globalFunction from 'util/GlobalFunction';
import { getSectionData } from "components/UIBuilder/Global/DataHelper";

export default class JobDetailDiv extends React.Component {
  constructor(props) {
    super();
    this.state = {
      data: {},
      manageLabelShow: false,
    }

    this.labelDiv = React.createRef();
  }

  //获取div数据
  componentDidMount() {
    if (this.props.section.autoLoad) {
      this.setState({ data: this.props.pageComponent.state.jobData });
    }
  }

  getSectionDataByDefault() {
    getSectionData({ component: this });
  }

  //创建显示UI - component
  createUI() {
    return this.props.viewConfig.groupList.map((group, i) =>
      <Descriptions
        key={i}
        bordered
        title={group.name}
        size={config.component.size}
        column={{ sm: 2, xs: 1 }}
      >
        {this.createGroupUI(group)}
      </Descriptions >)
  }

  //创建显示UI - Group
  createGroupUI(group) {
    return group.uieList.map((uie, i) => {
      return <Descriptions.Item
        label={uie.title}
        key={i}
        labelStyle={{ textAlign: 'right', width: '20%' }}
        contentStyle={{ width: uie.col === 12 ? '30%' : '80%' }}
      >{globalFunction.formatUieData({ uie: uie, data: this.state.data[uie.source], record: this.state.data, companyId: this.props.companyId, sectionComponent: this.parentComponent, pageComponent: this.props.pageComponent })}</Descriptions.Item>
    });
  }

  render() {
    return (
      <>
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>{this.createUI()}</Space >
      </>
    )
  }
}
